if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        if (this.dataset.randomizeProducts === 'true') {
          this.selectRandomProducts();
        }
        this.dataset.productsReady = 'true';

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      shuffle(items) {
        const shuffledItems = [...items];

        for (let index = shuffledItems.length - 1; index > 0; index -= 1) {
          let randomIndex;

          if (window.crypto?.getRandomValues) {
            const randomValues = new Uint32Array(1);
            window.crypto.getRandomValues(randomValues);
            randomIndex = randomValues[0] % (index + 1);
          } else {
            randomIndex = Math.floor(Math.random() * (index + 1));
          }

          [shuffledItems[index], shuffledItems[randomIndex]] = [shuffledItems[randomIndex], shuffledItems[index]];
        }

        return shuffledItems;
      }

      selectRandomProducts() {
        const products = Array.from(this.sliderWrapper.children);
        const productLimit = Math.min(parseInt(this.dataset.productLimit, 10) || products.length, products.length);
        const productsByType = new Map();

        products.forEach((product) => {
          const productType = product.dataset.productType || 'other';

          if (!productsByType.has(productType)) {
            productsByType.set(productType, []);
          }

          productsByType.get(productType).push(product);
        });

        let productTypes = this.shuffle(Array.from(productsByType.keys()));
        productTypes.forEach((productType) => {
          productsByType.set(productType, this.shuffle(productsByType.get(productType)));
        });

        const selectedProducts = [];
        while (selectedProducts.length < productLimit) {
          let productSelected = false;

          productTypes.forEach((productType) => {
            const productsOfType = productsByType.get(productType);

            if (productsOfType.length > 0 && selectedProducts.length < productLimit) {
              selectedProducts.push(productsOfType.pop());
              productSelected = true;
            }
          });

          if (!productSelected) break;
          productTypes = this.shuffle(productTypes);
        }

        const randomizedProducts = this.shuffle(selectedProducts);
        const selectedProductSet = new Set(randomizedProducts);
        products.forEach((product) => {
          if (!selectedProductSet.has(product)) product.remove();
        });

        const fragment = document.createDocumentFragment();
        randomizedProducts.forEach((product) => fragment.appendChild(product));
        this.sliderWrapper.appendChild(fragment);

        this.dataset.randomPoolSize = products.length;
        this.dataset.selectedProductTypes = new Set(
          randomizedProducts.map((product) => product.dataset.productType || 'other')
        ).size;
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            1280: {
              slidesPerView: parseInt(this.items),
            },
          },
          loop: true,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
